import { render, staticRenderFns } from "./element_pax.vue?vue&type=template&id=77dddb61&"
import script from "./element_pax.vue?vue&type=script&lang=js&"
export * from "./element_pax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports